const CRUD = Object.freeze({
  READ: 'view',
  UPDATE: 'update',
  DELETE: 'delete',
  CREATE: 'create',
})

export default CRUD
